import { render, staticRenderFns } from "./make_catequest_note.vue?vue&type=template&id=4bf060cc"
import script from "./make_catequest_note.vue?vue&type=script&lang=js"
export * from "./make_catequest_note.vue?vue&type=script&lang=js"
import style0 from "./make_catequest_note.vue?vue&type=style&index=0&id=4bf060cc&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports